import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/data/company";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300 mt-20"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={COMPANY.logo}
                alt="Finovest Holdings Ltd"
                className="w-16 h-16 object-contain"
              />
              <span className="font-serif text-xl tracking-[0.22em] text-white">
                FINOVEST
              </span>
            </div>
            <p className="mt-6 max-w-md text-slate-400 text-sm leading-relaxed">
              A private holdings group deploying institutional capital
              across fintech, healthcare, agriculture, real estate, and clean
              energy.
            </p>
            <p
              data-testid="footer-tagline"
              className="mt-6 font-serif italic text-amber-200/90 text-base leading-snug max-w-sm"
            >
              {COMPANY.tagline}
            </p>
            <div className="mt-6 text-[11px] tracking-[0.22em] uppercase text-slate-500">
              {COMPANY.registration}
            </div>
          </div>

          {/* Sitemap */}
          <div className="lg:col-span-3">
            <div className="overline text-slate-400">Sitemap</div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/opportunity"
                  data-testid="footer-link-opportunity"
                  className="text-sm text-emerald-400 hover:text-emerald-300 transition-colors"
                >
                  Submit Opportunity →
                </Link>
              </li>
            </ul>
          </div>

          {/* Offices */}
          <div className="lg:col-span-4 space-y-6">
            <div>
              <div className="overline text-slate-400">
                {COMPANY.addresses.bvi.label}
              </div>
              <div className="mt-3 flex items-start gap-2 text-sm text-slate-300">
                <MapPin size={16} className="mt-0.5 flex-none" />
                <span>{COMPANY.addresses.bvi.line}</span>
              </div>
            </div>
            <div>
              <div className="overline text-slate-400">
                {COMPANY.addresses.singapore.label}
              </div>
              <div className="mt-3 flex items-start gap-2 text-sm text-slate-300">
                <MapPin size={16} className="mt-0.5 flex-none" />
                <span>{COMPANY.addresses.singapore.line}</span>
              </div>
            </div>
            <div>
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email"
                className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
              >
                <Mail size={16} />
                {COMPANY.email}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-[11px] tracking-[0.22em] uppercase text-slate-500">
            © {new Date().getFullYear()} Finovest Holdings Ltd. All rights
            reserved.
          </div>
          <div className="text-[11px] tracking-[0.18em] uppercase text-slate-500">
            BVI · Singapore · Global
          </div>
        </div>
      </div>
    </footer>
  );
}
